var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"graph"}},[_c('fieldset',[_c('legend',[_vm._v("Graph")]),_c('cytoscape',{ref:"cy",attrs:{"config":_vm.config,"preConfig":_vm.preConfig}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }